//* Positive Answer (question settings): which edge answer counts as 100% implemented.
//* "No" is stored as custom scores that swap the Yes/No scores; every other answer keeps the framework's score.

export interface PositiveAnswerScore {
  answerKey: string;
  answerName: string;
  answerScore: number;
}

interface CustomScoreSettings {
  isCustomScore?: boolean;
  customScores?: { answerKey?: string; answerName?: string; answerScore?: number }[];
}

interface FrameworkAnswer {
  name: string;
  score: number;
}

//* true when the question's custom scores make No the 100% answer
export function isPositiveAnswerNo(settings: CustomScoreSettings): boolean {
  if (!settings?.isCustomScore || !settings?.customScores?.length) {
    return false;
  }
  const scoreOf = (key: string): number =>
    settings.customScores.find(
      score => score?.answerKey?.toUpperCase() === key || score?.answerName?.toUpperCase() === key
    )?.answerScore;
  const yes = scoreOf('YES');
  const no = scoreOf('NO');
  return yes !== undefined && yes !== null && no !== undefined && no !== null && no > yes;
}

//* custom scores for Positive Answer = No: Yes takes No's score and the reverse; Partial and N/A are left out
export function buildPositiveAnswerNoScores(frameworkAnswers: {
  YES?: FrameworkAnswer;
  NO?: FrameworkAnswer;
}): PositiveAnswerScore[] {
  const yes = frameworkAnswers?.YES;
  const no = frameworkAnswers?.NO;
  if (!yes || !no) {
    return [];
  }
  return [
    { answerKey: 'YES', answerName: yes.name, answerScore: no.score },
    { answerKey: 'NO', answerName: no.name, answerScore: yes.score },
  ];
}
